import { useBooleanState } from '@cian/react-utils';
import { Button, IconChevronLeft16, IconChevronRight16, TooltipDesktop } from '@cian/ui-kit';

import { type FC, useCallback } from 'react';

import { Switcher } from '../Switcher';

interface INarrowListToggleButtonProps {
  viewMode: 'map' | 'hybrid';
  onToggle: VoidFunction;
}

export const NarrowListToggleButton: FC<INarrowListToggleButtonProps> = ({ viewMode, onToggle }) => {
  const isHybridMode = viewMode === 'hybrid';

  const IconChevron16 = isHybridMode ? IconChevronLeft16 : IconChevronRight16;

  const tooltipTitle = isHybridMode ? 'Свернуть список' : 'Показать список';

  const { state: isTooltipOpen, setTrue: setTooltipOpen, setFalse: setTooltipClosed } = useBooleanState(false);

  const handleToggle = useCallback(() => {
    onToggle();
    setTooltipClosed();
  }, [onToggle, setTooltipClosed]);

  return (
    <TooltipDesktop open={isTooltipOpen} placement={isHybridMode ? 'left' : 'bottom'} title={tooltipTitle}>
      <Switcher>
        <Button
          beforeIcon={<IconChevron16 color="primary_100" />}
          data-testid="map-controls.toggle-map"
          size="M"
          theme="fill_white_primary"
          onClick={handleToggle}
          onMouseEnter={setTooltipOpen}
          onMouseLeave={setTooltipClosed}
        />
      </Switcher>
    </TooltipDesktop>
  );
};
